export default "__VITE_ASSET__5bbd74d2__"